import { render, staticRenderFns } from "./BlogOverviewItem.vue?vue&type=template&id=3700c605"
import script from "./BlogOverviewItem.vue?vue&type=script&lang=ts"
export * from "./BlogOverviewItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports